import { useEffect, useRef } from 'react';

import { Col, Row } from '@opendoor/atoms/box';
import { Button } from '@opendoor/atoms/button';
import { Image } from '@opendoor/atoms/image';
import { Link } from '@opendoor/atoms/link';
import { Text } from '@opendoor/atoms/text';
import Head from 'next/head';

const SUGGESTED_LINKS = [
  { label: 'Get an offer', href: 'https://www.opendoor.com/' },
  { label: 'View hundreds of homes', href: 'https://www.opendoor.com/homes' },
  { label: 'How it works', href: 'https://www.opendoor.com/how-it-works' },
  { label: 'Our customer stories', href: 'https://www.opendoor.com/stories' },
  { label: 'Contact Us', href: 'https://www.opendoor.com/contact-us' },
  { label: 'Read FAQs', href: 'https://help.opendoor.com' },
];

const SessionRateLimitedPage = ({ retry }: { retry: () => void }) => {
  const headingRef = useRef<HTMLHeadingElement | null>(null);
  useEffect(() => {
    headingRef.current?.focus();
  }, []);

  return (
    <>
      <Head>
        <title>Traffic jam — Opendoor</title>
        <link rel="shortcut icon" href="https://odfil.es/favicon.ico?v=2" type="image/x-icon" />
        <link rel="icon" href="https://odfil.es/favicon.ico?v=2" type="image/x-icon" />
      </Head>
      <Col as="main" className="min-h-screen bg-od-bg-primary text-center">
        <Col className="items-center gap-6 w-full bg-blue-50 px-6 pt-8 pb-16">
          <Image
            src="https://odfil.es/static/error/logo.svg"
            alt="Opendoor"
            width={150}
            height={40}
          />
          <Col className="items-center gap-2 max-w-xl">
            <Text as="h1" ref={headingRef} tabIndex={-1} className="text-header-lg text-blue-950">
              Traffic jam
            </Text>
            <Text as="p" className="text-body-lg text-od-content-secondary">
              The site is busier than usual. Please try again in a few minutes.
            </Text>
          </Col>
          <Image
            src="https://odfil.es/static/error/door-error-404.svg"
            alt=""
            width={400}
            height={400}
            className="w-full h-auto max-w-100 min-w-0"
          />
        </Col>

        <Col className="items-center gap-4 w-full px-6 py-12">
          <Row
            as="nav"
            aria-label="Suggested pages"
            className="flex-wrap justify-center items-center gap-x-5 gap-y-2 max-w-lg"
          >
            {SUGGESTED_LINKS.map((item) => (
              <Link
                key={item.href}
                href={item.href}
                analyticsName={`cosmos-session-rate-limited-link-${item.label}`}
              >
                {item.label}
              </Link>
            ))}
          </Row>
          <Button
            variant="primary"
            aria-label="Try again"
            analyticsName="cosmos-session-rate-limited-retry"
            onClick={retry}
          >
            Try again
          </Button>
        </Col>
      </Col>
    </>
  );
};

export default SessionRateLimitedPage;
